import { createSelector } from 'reselect'
import { getArgN, makeAPI } from './utils'
import * as Node from './node'
import * as selfExports from './schema'

/**
 * Mango Filter Schemas
 */

const getFilters = state => state.schemas.filters && state.schemas.filters

export const getAll = createSelector([ getFilters ], (schemas) => schemas)
export const getAllList = createSelector([ getAll ], (schemas) => Array.from(Object.values(schemas)))

export const get = createSelector([ getAll, getArgN(1) ], (schemas, schemaID) => {
  return schemas[schemaID]
})

export const getForNode = createSelector([ getAll, Node.get ], (schemas, node) => {
  return schemas[node.schemaID]
})

/**
 * Non-Filter Schemas
 */

export const getDataTypeSchemasRaw = state => {
  return (state.schemas.datatypes && state.schemas.datatypes) || {}
}

const getFileTypeSchemasRaw = state => {
  return (state.schemas.filetypes && state.schemas.filetypes) || {}
}

export const getDataTypeSchemas = createSelector([ getDataTypeSchemasRaw ], (dataTypes) => [...Object.values(dataTypes)])
export const getFileTypeSchemas = createSelector([ getFileTypeSchemasRaw ], (fileTypes) => [...Object.values(fileTypes)])

/**
 * Filter statuses
 */

export const RAW_STATUSES = Object.freeze(['stable', 'unstable', 'devel'])

export const STATUSES = {
  unstable: 'Production',
  devel: 'Development'
}

/**
 * Input data types e.g. 'Tomographic Data'
 */

export const ANY_DATATYPE = 'All Inputs'

export const getDataTypes = createSelector([ getDataTypeSchemas ], (datatypes) => {
  return [ANY_DATATYPE, ...datatypes.map(d => d.name)]
})

/**
 * Schema types i.e. analysis/creation/inplace
 */

export const ANY_SCHEMA_TYPE = 'All Types'

export const getSchemaTypes = createSelector([ getAllList ], (filters) => {
  return [ANY_SCHEMA_TYPE, ...new Set(filters.map(d => d.type))].filter(s => s !== 'inputdata')
})

export const ANY_FILETYPE = 'All File Types'

export const getOutputType = createSelector([ get, getArgN(2) ], (schema, input) => {
  let output = schema.types[input] || ''
  if (
    output === true || // has match
    !Object.keys(schema.types).length // accepts all if no types at all
  ) {
    output = input
  }
  return output
})

export const getAPI = makeAPI(selfExports, [
  getFilters,
  getDataTypeSchemasRaw,
  getFileTypeSchemasRaw
])



// WEBPACK FOOTER //
// ../webmango-core/selectors/schema.js